import React, {useState} from 'react';
import {HOME_PATH, PASSWORD_RESET_PATH} from "../../routes";
import useFeature from "../../useFeature";
import saporeLogo from "../../media/logos/logo-sapore.png";
import {observer} from "mobx-react";
import {LoginFeature} from "./LoginFeature";
import {useApplication} from "../../ApplicationProvider";
import {useNavigate} from "react-router-dom";
import WhatsAppButton from "../../components/Whatsapp";

const LoginView = () => {
    // TODO check if email and password fields will handle validation errors
    const [errors, setErrors] = useState({});
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useFeature(() => new LoginFeature(application))

    const redirectAfterLogin = () => {
        navigator(HOME_PATH)
    }

    const login = (event) => {
        event.preventDefault();
        feature.login(redirectAfterLogin)
    };

    const isFeatureReady = () => {
        return feature !== null;
    }

    return isFeatureReady() && (
        <div className="bg-login relative">
            <div className="center-center width100">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <img
                                        src={saporeLogo}
                                        className="img-logo-login"
                                        alt="Logo Sapore Di Pane"
                                    />
                                    <h3 className="text-center clearmargin">Ingresar</h3>
                                    <form className="form-material" role="form" onSubmit={login}>
                                        <div className="form-group label-floating is-fixed">
                                            <label htmlFor="username">Usuario</label>
                                            <input
                                                type="text"
                                                name="username"
                                                id="username"
                                                className="form-control"
                                                placeholder="Ingrese su usuario"
                                                value={feature.emailField().value}
                                                onChange={(e) => feature.updateEmail(e.target.value)}
                                            />
                                            {errors.email && <div className="text-danger">{errors.email}</div>}
                                        </div>
                                        <div className="form-group label-floating is-fixed">
                                            <label htmlFor="password">Contraseña</label>
                                            <input
                                                type="password"
                                                name="password"
                                                id="password"
                                                className="form-control"
                                                placeholder="Ingrese su contraseña"
                                                value={feature.passwordField().value}
                                                onChange={(e) => feature.updatePassword(e.target.value)}
                                            />
                                            {errors.password && <div className="text-danger">{errors.password}</div>}
                                        </div>
                                        <div className="form-login-actions text-center margintop50">
                                            <input type="submit" className="btn btn-primary form-control"
                                                   value="Ingresar"/>
                                            <a href={PASSWORD_RESET_PATH} className="forgotpass general-title">Olvidé mi
                                                contraseña</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <WhatsAppButton/>
        </div>
    );
};

export default observer(LoginView);